module.exports = __webpack_public_path__ + "static/media/DB-bardhe-03.61116bdd.svg";